import { GrowthDataSet } from '../../types/data-set.types';

export const whoBoysBmiMonthly: GrowthDataSet = {
  id: 'who-boys-bmi-monthly-0-5',
  source: 'WHO',
  title: 'BMI-for-age',
  intervalType: 'month',
  gender: 'male',
  measurementType: 'bmi',
  ageRange: { min: 0, max: 60 },
  displayUnit: 'kg/m²',
  dataPoints: [
    {
      age: 0,
      m: 13.4069,
      s: 0.0956,
      percentiles: {
        p1: 10.8,
        p3: 11.3,
        p5: 11.5,
        p15: 12.2,
        p25: 12.6,
        p50: 13.4,
        p75: 14.3,
        p85: 14.8,
        p95: 15.8,
        p97: 16.1,
        p99: 16.9,
      },
    },
    {
      age: 1,
      m: 14.9441,
      s: 0.09027,
      percentiles: {
        p1: 12.0,
        p3: 12.6,
        p5: 12.8,
        p15: 13.6,
        p25: 14.1,
        p50: 14.9,
        p75: 15.9,
        p85: 16.4,
        p95: 17.3,
        p97: 17.6,
        p99: 18.3,
      },
    },
    {
      age: 2,
      m: 16.3195,
      s: 0.08677,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14.1,
        p15: 14.9,
        p25: 15.4,
        p50: 16.3,
        p75: 17.3,
        p85: 17.8,
        p95: 18.8,
        p97: 19.2,
        p99: 19.9,
      },
    },
    {
      age: 3,
      m: 16.8987,
      s: 0.08495,
      percentiles: {
        p1: 13.9,
        p3: 14.4,
        p5: 14.7,
        p15: 15.5,
        p25: 16.0,
        p50: 16.9,
        p75: 17.9,
        p85: 18.5,
        p95: 19.4,
        p97: 19.8,
        p99: 20.6,
      },
    },
    {
      age: 4,
      m: 17.1579,
      s: 0.08378,
      percentiles: {
        p1: 14.1,
        p3: 14.7,
        p5: 15.0,
        p15: 15.7,
        p25: 16.2,
        p50: 17.2,
        p75: 18.2,
        p85: 18.7,
        p95: 19.7,
        p97: 20.1,
        p99: 20.9,
      },
    },
    {
      age: 5,
      m: 17.2919,
      s: 0.08296,
      percentiles: {
        p1: 14.3,
        p3: 14.8,
        p5: 15.1,
        p15: 15.9,
        p25: 16.4,
        p50: 17.3,
        p75: 18.3,
        p85: 18.9,
        p95: 19.8,
        p97: 20.2,
        p99: 21.0,
      },
    },
    {
      age: 6,
      m: 17.3422,
      s: 0.08234,
      percentiles: {
        p1: 14.4,
        p3: 14.9,
        p5: 15.2,
        p15: 15.9,
        p25: 16.4,
        p50: 17.3,
        p75: 18.3,
        p85: 18.9,
        p95: 19.9,
        p97: 20.3,
        p99: 21.1,
      },
    },
    {
      age: 7,
      m: 17.3288,
      s: 0.08183,
      percentiles: {
        p1: 14.4,
        p3: 14.9,
        p5: 15.2,
        p15: 15.9,
        p25: 16.4,
        p50: 17.3,
        p75: 18.3,
        p85: 18.9,
        p95: 19.9,
        p97: 20.3,
        p99: 21.1,
      },
    },
    {
      age: 8,
      m: 17.2647,
      s: 0.0814,
      percentiles: {
        p1: 14.4,
        p3: 14.9,
        p5: 15.1,
        p15: 15.9,
        p25: 16.3,
        p50: 17.3,
        p75: 18.2,
        p85: 18.8,
        p95: 19.8,
        p97: 20.2,
        p99: 21.0,
      },
    },
    {
      age: 9,
      m: 17.1662,
      s: 0.08102,
      percentiles: {
        p1: 14.3,
        p3: 14.8,
        p5: 15.1,
        p15: 15.8,
        p25: 16.3,
        p50: 17.2,
        p75: 18.1,
        p85: 18.7,
        p95: 19.7,
        p97: 20.1,
        p99: 20.8,
      },
    },
    {
      age: 10,
      m: 17.0488,
      s: 0.08068,
      percentiles: {
        p1: 14.2,
        p3: 14.7,
        p5: 15.0,
        p15: 15.7,
        p25: 16.2,
        p50: 17.0,
        p75: 18.0,
        p85: 18.6,
        p95: 19.5,
        p97: 19.9,
        p99: 20.7,
      },
    },
    {
      age: 11,
      m: 16.9239,
      s: 0.08037,
      percentiles: {
        p1: 14.1,
        p3: 14.6,
        p5: 14.9,
        p15: 15.6,
        p25: 16.0,
        p50: 16.9,
        p75: 17.9,
        p85: 18.4,
        p95: 19.4,
        p97: 19.8,
        p99: 20.5,
      },
    },
    {
      age: 12,
      m: 16.7981,
      s: 0.08009,
      percentiles: {
        p1: 14.0,
        p3: 14.5,
        p5: 14.8,
        p15: 15.5,
        p25: 15.9,
        p50: 16.8,
        p75: 17.7,
        p85: 18.3,
        p95: 19.2,
        p97: 19.6,
        p99: 20.4,
      },
    },
    {
      age: 13,
      m: 16.6743,
      s: 0.07982,
      percentiles: {
        p1: 13.9,
        p3: 14.4,
        p5: 14.7,
        p15: 15.4,
        p25: 15.8,
        p50: 16.7,
        p75: 17.6,
        p85: 18.1,
        p95: 19.1,
        p97: 19.5,
        p99: 20.2,
      },
    },
    {
      age: 14,
      m: 16.5548,
      s: 0.07958,
      percentiles: {
        p1: 13.9,
        p3: 14.3,
        p5: 14.6,
        p15: 15.3,
        p25: 15.7,
        p50: 16.6,
        p75: 17.5,
        p85: 18.0,
        p95: 18.9,
        p97: 19.3,
        p99: 20.1,
      },
    },
    {
      age: 15,
      m: 16.4409,
      s: 0.07935,
      percentiles: {
        p1: 13.8,
        p3: 14.2,
        p5: 14.5,
        p15: 15.2,
        p25: 15.6,
        p50: 16.4,
        p75: 17.4,
        p85: 17.9,
        p95: 18.8,
        p97: 19.2,
        p99: 19.9,
      },
    },
    {
      age: 16,
      m: 16.3335,
      s: 0.07913,
      percentiles: {
        p1: 13.7,
        p3: 14.2,
        p5: 14.4,
        p15: 15.1,
        p25: 15.5,
        p50: 16.3,
        p75: 17.2,
        p85: 17.8,
        p95: 18.7,
        p97: 19.1,
        p99: 19.8,
      },
    },
    {
      age: 17,
      m: 16.2329,
      s: 0.07892,
      percentiles: {
        p1: 13.6,
        p3: 14.1,
        p5: 14.3,
        p15: 15.0,
        p25: 15.4,
        p50: 16.2,
        p75: 17.1,
        p85: 17.6,
        p95: 18.6,
        p97: 18.9,
        p99: 19.7,
      },
    },
    {
      age: 18,
      m: 16.1392,
      s: 0.07873,
      percentiles: {
        p1: 13.6,
        p3: 14.0,
        p5: 14.2,
        p15: 14.9,
        p25: 15.3,
        p50: 16.1,
        p75: 17.0,
        p85: 17.5,
        p95: 18.5,
        p97: 18.8,
        p99: 19.6,
      },
    },
    {
      age: 19,
      m: 16.0528,
      s: 0.07854,
      percentiles: {
        p1: 13.5,
        p3: 13.9,
        p5: 14.2,
        p15: 14.8,
        p25: 15.2,
        p50: 16.1,
        p75: 16.9,
        p85: 17.4,
        p95: 18.4,
        p97: 18.7,
        p99: 19.5,
      },
    },
    {
      age: 20,
      m: 15.9743,
      s: 0.07836,
      percentiles: {
        p1: 13.4,
        p3: 13.9,
        p5: 14.1,
        p15: 14.8,
        p25: 15.2,
        p50: 16.0,
        p75: 16.9,
        p85: 17.4,
        p95: 18.3,
        p97: 18.6,
        p99: 19.4,
      },
    },
    {
      age: 21,
      m: 15.9039,
      s: 0.07818,
      percentiles: {
        p1: 13.4,
        p3: 13.8,
        p5: 14.1,
        p15: 14.7,
        p25: 15.1,
        p50: 15.9,
        p75: 16.8,
        p85: 17.3,
        p95: 18.2,
        p97: 18.6,
        p99: 19.3,
      },
    },
    {
      age: 22,
      m: 15.8412,
      s: 0.07802,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14.0,
        p15: 14.6,
        p25: 15.0,
        p50: 15.8,
        p75: 16.7,
        p85: 17.2,
        p95: 18.1,
        p97: 18.5,
        p99: 19.2,
      },
    },
    {
      age: 23,
      m: 15.7852,
      s: 0.07786,
      percentiles: {
        p1: 13.3,
        p3: 13.7,
        p5: 14.0,
        p15: 14.6,
        p25: 15.0,
        p50: 15.8,
        p75: 16.7,
        p85: 17.1,
        p95: 18.0,
        p97: 18.4,
        p99: 19.1,
      },
    },
    {
      age: 24,
      m: 15.7356,
      s: 0.07771,
      percentiles: {
        p1: 13.3,
        p3: 13.7,
        p5: 13.9,
        p15: 14.5,
        p25: 14.9,
        p50: 15.7,
        p75: 16.6,
        p85: 17.1,
        p95: 18.0,
        p97: 18.3,
        p99: 19.1,
      },
    },
    {
      age: 25,
      m: 15.98,
      s: 0.07792,
      percentiles: {
        p1: 13.5,
        p3: 13.9,
        p5: 14.1,
        p15: 14.8,
        p25: 15.2,
        p50: 16.0,
        p75: 16.9,
        p85: 17.4,
        p95: 18.3,
        p97: 18.6,
        p99: 19.4,
      },
    },
    {
      age: 26,
      m: 15.9414,
      s: 0.078,
      percentiles: {
        p1: 13.4,
        p3: 13.8,
        p5: 14.1,
        p15: 14.7,
        p25: 15.1,
        p50: 15.9,
        p75: 16.8,
        p85: 17.3,
        p95: 18.2,
        p97: 18.6,
        p99: 19.3,
      },
    },
    {
      age: 27,
      m: 15.9036,
      s: 0.07808,
      percentiles: {
        p1: 13.4,
        p3: 13.8,
        p5: 14.0,
        p15: 14.7,
        p25: 15.1,
        p50: 15.9,
        p75: 16.8,
        p85: 17.3,
        p95: 18.2,
        p97: 18.5,
        p99: 19.2,
      },
    },
    {
      age: 28,
      m: 15.8667,
      s: 0.07818,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14.0,
        p15: 14.7,
        p25: 15.1,
        p50: 15.9,
        p75: 16.7,
        p85: 17.2,
        p95: 18.1,
        p97: 18.5,
        p99: 19.2,
      },
    },
    {
      age: 29,
      m: 15.8306,
      s: 0.07829,
      percentiles: {
        p1: 13.3,
        p3: 13.7,
        p5: 14.0,
        p15: 14.6,
        p25: 15.0,
        p50: 15.8,
        p75: 16.7,
        p85: 17.2,
        p95: 18.1,
        p97: 18.4,
        p99: 19.1,
      },
    },
    {
      age: 30,
      m: 15.7953,
      s: 0.07841,
      percentiles: {
        p1: 13.3,
        p3: 13.7,
        p5: 13.9,
        p15: 14.6,
        p25: 15.0,
        p50: 15.8,
        p75: 16.7,
        p85: 17.2,
        p95: 18.0,
        p97: 18.4,
        p99: 19.1,
      },
    },
    {
      age: 31,
      m: 15.7606,
      s: 0.07854,
      percentiles: {
        p1: 13.2,
        p3: 13.7,
        p5: 13.9,
        p15: 14.5,
        p25: 15.0,
        p50: 15.8,
        p75: 16.6,
        p85: 17.1,
        p95: 18.0,
        p97: 18.4,
        p99: 19.1,
      },
    },
    {
      age: 32,
      m: 15.7267,
      s: 0.07867,
      percentiles: {
        p1: 13.2,
        p3: 13.6,
        p5: 13.9,
        p15: 14.5,
        p25: 14.9,
        p50: 15.7,
        p75: 16.6,
        p85: 17.1,
        p95: 18.0,
        p97: 18.3,
        p99: 19.0,
      },
    },
    {
      age: 33,
      m: 15.6934,
      s: 0.07882,
      percentiles: {
        p1: 13.1,
        p3: 13.6,
        p5: 13.8,
        p15: 14.5,
        p25: 14.9,
        p50: 15.7,
        p75: 16.6,
        p85: 17.0,
        p95: 17.9,
        p97: 18.3,
        p99: 19.0,
      },
    },
    {
      age: 34,
      m: 15.661,
      s: 0.07897,
      percentiles: {
        p1: 13.1,
        p3: 13.5,
        p5: 13.8,
        p15: 14.4,
        p25: 14.9,
        p50: 15.7,
        p75: 16.5,
        p85: 17.0,
        p95: 17.9,
        p97: 18.2,
        p99: 18.9,
      },
    },
    {
      age: 35,
      m: 15.6294,
      s: 0.07914,
      percentiles: {
        p1: 13.1,
        p3: 13.5,
        p5: 13.8,
        p15: 14.4,
        p25: 14.8,
        p50: 15.6,
        p75: 16.5,
        p85: 17.0,
        p95: 17.9,
        p97: 18.2,
        p99: 18.9,
      },
    },
    {
      age: 36,
      m: 15.5988,
      s: 0.07931,
      percentiles: {
        p1: 13.0,
        p3: 13.5,
        p5: 13.7,
        p15: 14.4,
        p25: 14.8,
        p50: 15.6,
        p75: 16.5,
        p85: 17.0,
        p95: 17.8,
        p97: 18.2,
        p99: 18.9,
      },
    },
    {
      age: 37,
      m: 15.5693,
      s: 0.0795,
      percentiles: {
        p1: 13.0,
        p3: 13.5,
        p5: 13.7,
        p15: 14.4,
        p25: 14.8,
        p50: 15.6,
        p75: 16.4,
        p85: 16.9,
        p95: 17.8,
        p97: 18.1,
        p99: 18.8,
      },
    },
    {
      age: 38,
      m: 15.541,
      s: 0.07969,
      percentiles: {
        p1: 13.0,
        p3: 13.4,
        p5: 13.7,
        p15: 14.3,
        p25: 14.7,
        p50: 15.5,
        p75: 16.4,
        p85: 16.9,
        p95: 17.8,
        p97: 18.1,
        p99: 18.8,
      },
    },
    {
      age: 39,
      m: 15.514,
      s: 0.0799,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.5,
        p75: 16.4,
        p85: 16.9,
        p95: 17.7,
        p97: 18.1,
        p99: 18.8,
      },
    },
    {
      age: 40,
      m: 15.4885,
      s: 0.08012,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.5,
        p75: 16.4,
        p85: 16.8,
        p95: 17.7,
        p97: 18.1,
        p99: 18.8,
      },
    },
    {
      age: 41,
      m: 15.4645,
      s: 0.08036,
      percentiles: {
        p1: 12.9,
        p3: 13.3,
        p5: 13.6,
        p15: 14.2,
        p25: 14.7,
        p50: 15.5,
        p75: 16.3,
        p85: 16.8,
        p95: 17.7,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 42,
      m: 15.442,
      s: 0.08061,
      percentiles: {
        p1: 12.9,
        p3: 13.3,
        p5: 13.6,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.7,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 43,
      m: 15.421,
      s: 0.08087,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.7,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 44,
      m: 15.4013,
      s: 0.08115,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.7,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 45,
      m: 15.3827,
      s: 0.08144,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 46,
      m: 15.3652,
      s: 0.08174,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.1,
        p25: 14.5,
        p50: 15.4,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 47,
      m: 15.3485,
      s: 0.08205,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.1,
        p25: 14.5,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 48,
      m: 15.3326,
      s: 0.08238,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 49,
      m: 15.3174,
      s: 0.08272,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 50,
      m: 15.3029,
      s: 0.08307,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 51,
      m: 15.2891,
      s: 0.08343,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.4,
        p15: 14.0,
        p25: 14.5,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 52,
      m: 15.2759,
      s: 0.0838,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.4,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 53,
      m: 15.2633,
      s: 0.08418,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.7,
      },
    },
    {
      age: 54,
      m: 15.2514,
      s: 0.08457,
      percentiles: {
        p1: 12.6,
        p3: 13.1,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.8,
      },
    },
    {
      age: 55,
      m: 15.24,
      s: 0.08496,
      percentiles: {
        p1: 12.6,
        p3: 13.1,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.2,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.8,
      },
    },
    {
      age: 56,
      m: 15.2291,
      s: 0.08536,
      percentiles: {
        p1: 12.6,
        p3: 13.1,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.2,
        p75: 16.1,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.8,
      },
    },
    {
      age: 57,
      m: 15.2188,
      s: 0.08577,
      percentiles: {
        p1: 12.6,
        p3: 13.0,
        p5: 13.3,
        p15: 14.0,
        p25: 14.4,
        p50: 15.2,
        p75: 16.1,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.8,
      },
    },
    {
      age: 58,
      m: 15.2091,
      s: 0.08617,
      percentiles: {
        p1: 12.6,
        p3: 13.0,
        p5: 13.3,
        p15: 13.9,
        p25: 14.4,
        p50: 15.2,
        p75: 16.1,
        p85: 16.7,
        p95: 17.6,
        p97: 18.0,
        p99: 18.8,
      },
    },
    {
      age: 59,
      m: 15.2,
      s: 0.08659,
      percentiles: {
        p1: 12.6,
        p3: 13.0,
        p5: 13.3,
        p15: 13.9,
        p25: 14.4,
        p50: 15.2,
        p75: 16.1,
        p85: 16.7,
        p95: 17.7,
        p97: 18.1,
        p99: 18.9,
      },
    },
    {
      age: 60,
      m: 15.1916,
      s: 0.087,
      percentiles: {
        p1: 12.6,
        p3: 13.0,
        p5: 13.3,
        p15: 13.9,
        p25: 14.3,
        p50: 15.2,
        p75: 16.1,
        p85: 16.7,
        p95: 17.7,
        p97: 18.1,
        p99: 18.9,
      },
    },
  ],
};
